/**
 * An error response of the API, with its HTTP status and the error code of
 * the backend. The REST API and GraphQL (`extensions.status` and
 * `extensions.code`) both supply these fields, so the query cache can treat
 * the errors of both transports the same way.
 *
 * Note: when GraphQL queries move to TanStack Query, decide how to handle
 * partial data. Apollo uses `errorPolicy: "all"` and returns the data and the
 * errors together, but a query function can only return data or throw.
 */
export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string | undefined,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}
